// extracted by mini-css-extract-plugin
module.exports =  {"aiComponent":"aiComponent--bCc9M","empty":"empty--OJA0J"};